<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-istoric">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title class="d-flex justify-content-between">
                                <span>
                                    <i class="fa-regular fa-comments"></i>
                                    <span>Istoric</span>
                                </span>
                                <span class="action-buttons" *ngIf="history.length">
                                    <!-- Exportă operator -->
                                    <!-- <button class="btn btn-light d-flex justify-content-center align-items-center"
                                        (click)="exportConv(1)">
                                        <ng-container *ngIf="isLoadingOperator; else exportOperatorIcon">
                                            <mat-spinner diameter="20"></mat-spinner>
                                        </ng-container>
                                        <ng-template #exportOperatorIcon>
                                            <i class="fa-regular fa-file"></i>
                                        </ng-template>
                                        Exportă operator
                                    </button> -->

                                    <!-- Exportă tot -->
                                    <button class="btn btn-light d-flex justify-content-center align-items-center"
                                        (click)="exportConv(3)">
                                        <ng-container *ngIf="isLoadingAll; else exportAllIcon">
                                            <mat-spinner diameter="20"></mat-spinner>
                                        </ng-container>
                                        <ng-template #exportAllIcon>
                                            <i class="fa-regular fa-file"></i>
                                        </ng-template>
                                        Exportă
                                    </button>

                                    <form [formGroup]="searchParamsForm">
                                        <mat-form-field>
                                            <mat-label>Tip mesaj</mat-label>
                                            <mat-select formControlName="messageFilter"
                                                (selectionChange)="filterHistoryByType()">
                                                <mat-option *ngFor="let message of messageFilters"
                                                    [value]="message.filters">
                                                    {{ message.key }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </form>
                                </span>
                            </mat-card-title>
                        </div>
                    </div>
                </div>
                <div class="box-content-body p-2">
                    <div *ngFor="let ist of filteredHistory; let i = index" class="box-message"
                        [class.client]="ist.type == 0" [class.to-client]="ist.type == 1" [class.intern]="ist.type == 2"
                        [class.note]="ist.type == 3" [class.me]="user.id_user == ist.user_id && ist.type !== 0">
                        <div class="box-chat">
                            <div class="box-chat-header">
                                <div>
                                    <!-- <span *ngIf="ist.type == 0">Răspuns cetățean</span>
                                    <span *ngIf="ist.type == 1">Mesaj către cetățean</span> -->
                                    <span *ngIf="ist.type == 2">Mesaj intern</span>
                                    <span *ngIf="ist.type == 3">Notă</span>
                                </div>
                            </div>

                            <div class="message-content" [innerHTML]="ist.content"></div>
                            <!-- here to add files if present!!! -->
                            <div class="doc-attachment p-2" *ngIf="ist.files && ist.files.length > 0">
                                <button type="button" class="btn btn-light upload-btn m-2"
                                    *ngFor="let file of ist.files" (click)="downloadDocument(file)">
                                    <span class="upload__text">
                                        {{ file.original_name }}
                                    </span>
                                </button>
                            </div>

                            <!-- Coleagues -->
                            <div *ngIf="ist.notified && ist.notified.length" class="notifications-container">
                                <div *ngFor="let colleague of ist.notified"
                                    class="d-flex justify-content-end notification-item">
                                    <span class="p-2">
                                        <i class="fa-regular fa-user"></i> {{colleague.user_name}}
                                    </span>
                                    <!-- <span class="p-2" title="{{colleague.processed_web}}">
                                        <i class="fa-solid fa-flag"
                                            [style.color]="colleague.processed_web === null ? 'red' : 'grey'"></i>
                                    </span> -->
                                    <!-- <span class="p-2" title="{{colleague.processed_email_date}}">
                                        <i class="fa-solid fa-envelope"
                                            [style.color]="colleague.processed_email_date === null ? 'red' : 'grey'"></i>
                                    </span> -->
                                </div>
                            </div>
                        </div>
                        <div class="box-chat-footer">
                            <small>
                                <i class="fa-regular fa-user"></i> {{ist.user_name}}
                            </small>
                            <small>
                                <i class="fa-regular fa-clock"></i> {{ist.created_at | date: "dd.MM.yyyy HH:mm" : "ro"}}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>